import { Box, Divider, Icon, Typography } from '@mui/material'

const WorkExperienceCard = ({
  unlocked,
  position = 'Prime Minister',
  company = 'Invoke',
  startMonth = '09',
  endMonth = '09',
  startYear = '2021',
  endYear = '2022',
  duration,
  salary = 'RM 19,999',
  current,
  jobDesc,
}) => {
  const splitWord = (text) => {
    if (text.includes('●')) {
      const arr = text.split('●')
      const cleanedArr = arr.filter((point) => point.trim() !== '')
      const addBulletPointArr = cleanedArr.map((point) => '● ' + point.trim())

      return addBulletPointArr
    }
    return text
  }
  const jobDescription = splitWord(jobDesc)
  return (
    <Box paddingX={2}>
      <Typography
        variant="h4"
        color="dark-text.main"
        paddingY={1}
        align="left"
        marginBottom={2}
        sx={{
          fontWeight: 'bold',
          textTransform: 'capitalize',
        }}
      >
        {position}
      </Typography>
      <Box display="flex" gap={9}>
        <Typography
          width={80}
          variant="body1"
          color="light-gray-text.main"
          align="left"
          marginBottom={2}
        >
          Company
        </Typography>
        <Typography
          display="flex"
          alignItems="center"
          variant="body1"
          color="light-gray-text.main"
          align="left"
          marginBottom={2}
        >
          {unlocked ? (
            company
          ) : (
            <>
              <Icon sx={{ color: 'alternate.main', fontSize: '20px' }}>lock</Icon>
              Purchase to view
            </>
          )}
        </Typography>
      </Box>
      <Box display="flex" gap={9}>
        <Typography
          width={80}
          variant="body1"
          color="light-gray-text.main"
          align="left"
          marginBottom={2}
        >
          Duration
        </Typography>
        <Typography variant="body1" color="dark-text.main" align="left" marginBottom={2}>
          {startMonth}/{startYear} - {current === 1 ? 'PRESENT' : `${endMonth}/${endYear}`}
        </Typography>
      </Box>
      {/* hide salary for now */}
      {/* <Box display="flex" gap={9}>
        <Typography
          width={80}
          variant="body1"
          color="light-gray-text.main"
          align="left"
          marginBottom={2}
        >
          Salary
        </Typography>
        <Typography variant="body1" color="dark-text.main" align="left" marginBottom={2}>
          RM {salary}
        </Typography>
      </Box> */}
      <Box display="flex" flexDirection="column">
        <Typography variant="body1" color="light-gray-text.main" align="left">
          Job Description
        </Typography>
        <Box
          display="flex"
          flexDirection="column"
          sx={{ whiteSpace: 'wrap', wordBreak: 'break-word' }}
        >
          {Array.isArray(jobDescription) ? (
            jobDescription?.map((item, index) => (
              <Typography
                key={index}
                variant="body1"
                color="dark-text.main"
                align="left"
                marginBottom={2}
                textAlign="justify"
                maxWidth="95%"
              >
                {item}
              </Typography>
            ))
          ) : (
            <Typography
              variant="body1"
              color="dark-text.main"
              align="left"
              marginBottom={2}
              textAlign="justify"
              maxWidth="95%"
            >
              {/* {splitWord(jobDesc)} */}
              {jobDesc}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  )
}
export default WorkExperienceCard
